import { Label as LabelType } from '@yleisradio/areena-types';
import React from 'react';
import classNames from 'classnames';
import styles from './HeaderLabels.module.scss';
import { isRestrictionLabel } from 'components/Label/ContentRatingImage';
import { Label } from 'components/Label';
import { getLabelKey } from 'utils/card';

type Separator = 'bullet' | 'line' | 'lineBreak';
type Props = {
  labels: LabelType[];
  separator: Separator;
  cardKey: string;
};

const getLabelClassName = (label: LabelType, separator: Separator) =>
  classNames(
    styles.label,
    separator === 'line' && styles.labelWithLineSeparator,
    separator === 'lineBreak' && styles.labelWithLineBreakSeparator,
    isRestrictionLabel(label) && styles.labelWithSpaceSeparator
  );

export const HeaderLabels: React.FunctionComponent<Props> = ({
  labels,
  separator,
  cardKey,
}) => {
  if (!labels || !labels.length) return null;

  return (
    <div
      className={classNames(
        styles.container,
        separator === 'lineBreak' && styles.lineBreak
      )}
      data-testid="header-labels"
    >
      {labels.reduce<(React.ReactElement | string)[]>((acc, label, index) => {
        const Element = separator === 'lineBreak' ? 'div' : 'span';
        acc.push(
          <Element
            key={getLabelKey(label, cardKey)}
            className={getLabelClassName(label, separator)}
          >
            <Label label={label} />
          </Element>,
          ' '
        );

        if (
          separator === 'bullet' &&
          !isRestrictionLabel(label) &&
          index < labels.length - 1
        )
          acc.push(
            <span key={index} className={styles.bullet}>
              {'·'}
            </span>,
            ' '
          );

        return acc;
      }, [])}
    </div>
  );
};
